import { useMutation } from '@tanstack/react-query';
import { HttpStatusCode } from 'axios';
import i18next from 'i18next';
import { appointmentApi } from 'service/api/appointmentApi';
import { useNotification } from 'utils/notification/NotificationContext';
import type { CustomError } from '@dvag/dfs-api-client';
import { Feedback } from '../type/advisor';

interface PropTypes {
  householdId: string;
  appointmentId: string;
}

export const useCreateFeedback = ({ householdId, appointmentId }: PropTypes) => {
  const { showDefault, showError } = useNotification();
  const appointmentService = appointmentApi();
  return useMutation<Feedback, CustomError, Feedback, unknown>({
    mutationFn: async (values: Feedback) => {
      const response = await appointmentService.postFeedback({
        appointmentId,
        householdId,
        ...values,
      });
      return response.data;
    },
    onError: (error) => {
      if (error?.status === HttpStatusCode.PayloadTooLarge) {
        showDefault({
          title: i18next.t('general.toasters.loading.payloadTooLarge.description'),
          noTitle: false,
        });
      } else {
        showError({ status: error?.status });
      }
    },
  });
};
